import type { NextPage } from 'next'
// import Image from 'next/image'
import styles from '../../styles/Logo.module.scss'
import { joinClassnames } from 'helpers/classNames'
import { Size } from 'types/size'
// import logo from 'images/logo.png'

interface Props {
  size?: Size
}

const Logo: NextPage<Props> = (props: Props) => {

  const className = joinClassnames([
    styles.logo_wrapper,
    props.size === Size.small && styles.small,
    props.size === Size.medium && styles.medium,
    props.size === Size.xSmall && styles.xSmall,
  ])
  return (
    <div className={className}>
      <img
        // loader={myLoader}
        src={"/logo.png"}
        alt="brizup logo"
        className={styles.logo}
      />
    </div>
  )
}

export default Logo
